module.exports = __webpack_public_path__ + "static/img/agb_3.ee7c441.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/agb_3.png
// module id = 1244
// module chunks = 1